import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
// import { offline, persist } from './persistance'
import { map } from '../views/utils'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  mutations,
  getters,
  modules: map(modules, module => module.store || {}),
  // plugins: [persist],
  strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/store/index.js